import React from 'react';
import styles from './ellipse.module.scss';

const Ellipse = () => {
  const scrollToFooter = () => {
    const footer = document.getElementById('footer');
    footer?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={styles.container} onClick={scrollToFooter}>
      <div className={styles.dot}></div>
    </div>
  );
};

export default Ellipse;
